<template>
  <div class="payment-status" v-cloak>
    <!--失败时： 用icon-iconfontguanbi fail替换icon-duihao2 bg-color-red-->
    <div class="iconfont icon-duihao2 bg-color-red"
      v-if="orderInfo.paid || orderInfo.pay_type == 'offline' || orderInfo.buyMethod != 'quanKuan'"></div>
    <div class="iconfont icon-iconfontguanbi fail" v-else></div>
    <!-- 失败时：订单支付失败 -->
  
    <div class='status' v-if="orderInfo.pay_type != 'offline' && orderInfo.buyMethod == 'quanKuan'">{{orderInfo.paid ? '订单支付成功':'订单支付失败'}}</div>
    <div class='status' v-else>订单创建成功</div>

    <template v-if="orderInfo.order_id">
      <div class="wrapper">
        <div class="item acea-row row-between-wrapper">
          <div>订单编号</div>
          <div class="itemCom" v-text="orderInfo.order_id"></div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>下单时间</div>
          <div class="itemCom" v-text="orderInfo._add_time"></div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>支付方式</div>
          <div class="itemCom">
            {{orderInfo.buyMethod != 'quanKuan' ? orderInfo.buyMethodDes : orderInfo._status._payType}}
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>支付金额</div>
          <div class="itemCom" v-text="orderInfo.pay_price"></div>
        </div>
        <!--分期订单加上这个  -->
        <div class='item acea-row row-between-wrapper' v-if="orderInfo.buyMethod != 'quanKuan'">
          <div>温馨提示</div>
          <div class='itemCom'>{{msgContent}}</div>
        </div>
        <!--失败时加上这个  -->
        <div class="item acea-row row-between-wrapper" v-else-if="orderInfo.paid == 0 && orderInfo.pay_type != 'offline' && msgContent">
          <div>失败原因</div>
          <div class="itemCom" v-text="msgContent"></div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="wrapper">
        <div class="item acea-row row-between-wrapper">
          <div>订单编号</div>
          <div class="itemCom" v-text="id"></div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>失败原因</div>
          <div class="itemCom">{{msgContent}}</div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>温馨提示</div>
          <div class="itemCom">请先登录或回微信再查看订单详情</div>
        </div>
      </div>
    </template>

    <!--客服二维码  -->
    <div class="constomerQr" v-if="customerQrUrl != ''">
      <div class="tips">请长按添加客服号，方便安排发货等事宜</div>
      <div class='qr'>
        <img :src='customerQrUrl' class="qr-image"></img>
      </div>
    </div>

    <template v-if="orderInfo.order_id">
      <div class="returnBnt bg-color-red" @click="goPages()">查看订单</div>
      <div style="height: 0.3rem;"></div>
      <div class="returnBnt cart-color" @click="goPages('/')">返回首页</div>
    </template>
    <template v-else>
      <div style="height: 0.3rem;"></div>
      <div class="returnBnt bg-color-red" @click="goPages('/')">返回首页</div>
      <div style="height: 0.3rem;"></div>
    </template>
  </div>
</template>

<style>
.payment-status .constomerQr {
  border-bottom: 1px solid #eee;
  margin: -0.47rem 0.30rem 0.47rem 0.30rem;
  padding-top: 0.35rem;
  border-left: 0;
  border-right: 0;
}

.payment-status .constomerQr .tips {
  font-size: 0.26rem;
  text-align: center;
  color:#666;
}

.payment-status .constomerQr .qr {
  text-align: center;
}
.payment-status .constomerQr .qr .qr-image {
  width: 3rem;
  height: 3rem;
}
</style>

<script>
import { mapGetters } from "vuex";
import { orderDetail } from "@api/order";
import { isWeixin } from "@utils";
import { getCustomerQr } from "@api/public"

const NAME = "PayMentStatus";

export default {
  name: NAME,
  props: {},
  data: function () {
    return {
      id: "",
      status: 0,
      msgContent: "",
      orderInfo: {},
      isWeixin: isWeixin(),
      customerQrUrl: ''
    };
  },
  watch: {
    $route(n) {
      if (n.query.msg) this.msgContent = n.query.msg;
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
        this.status = parseInt(n.params.status);
        this.getOrderInfo();
      }
    }
  },
  computed: {
    // ...mapGetters(["userInfo"])
  },
  mounted() {
    this.id = this.$route.params.id;
    this.msgContent = this.$route.query.msg;
    this.status = parseInt(this.$route.params.status);
    this.getOrderInfo();
    this.getCustomerQr();
  },
  methods: {
    goPages(route) {
      let routes = (route !== undefined ? route: "/order/detail/" + this.orderInfo.order_id);
      if (this.status === 5 && route === undefined) {
        routes = "/order/list/0";
      }
      return this.$router.push({
        path: routes
      });
    },
    getOrderInfo() {
      if(!this.$store.state.app.token) {
        return;
      }
      orderDetail(this.id).then(res => {
        this.orderInfo = res.data;
        let title = '';
        if (res.data.buyMethod != 'quanKuan') {
          title = '提交成功';
          this.msgContent += '，请等待审核结果'
        } else {
          title = res.data.paid ? '支付成功' : '支付失败'
        }
        document.title = title;
      }).catch(err => {
        this.$dialog.error(err.msg);
      });
    },
    getCustomerQr() {
      getCustomerQr().then(res => {
        this.customerQrUrl = res.data.customerQrUrl
      })
      .catch(err => {
        
      });;
    }
    
  }
};
</script>
